import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";
import HighlightText from "./HighlightText";

interface NewsCardProps {
  item: NewsItem;
  query?: string;
  layout?: "grid" | "list";
}

export default function NewsCard({ item, query = "", layout = "grid" }: NewsCardProps) {
  if (layout === "list") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-300 transition-colors p-3 md:p-4"
      >
        <div className="w-full sm:w-56 shrink-0 aspect-[8/5] rounded-md overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 舒淇动态资讯配图`}
            title={`${item.title} 舒淇最新动态`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex-1 flex flex-col">
          <div className="flex items-center gap-3 text-xs text-secondary-500">
            <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700">
              {item.category}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line" />
              {item.date}
            </span>
          </div>
          <h3 className="mt-2 font-heading text-base md:text-lg font-semibold text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
            <HighlightText text={item.title} query={query} />
          </h3>
          <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
            {item.summary}
          </p>
          <span className="mt-auto pt-3 text-xs text-accent-600 inline-flex items-center gap-1">
            阅读详情
            <i className="ri-arrow-right-line" />
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-300 transition-colors"
    >
      <div className="w-full aspect-[8/5] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 舒淇动态资讯配图`}
          title={`${item.title} 舒淇最新动态`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-secondary-500">
          <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700">
            {item.category}
          </span>
          <span>{item.date}</span>
        </div>
        <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
          <HighlightText text={item.title} query={query} />
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-3 leading-relaxed">
          {item.summary}
        </p>
      </div>
    </Link>
  );
}